(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("analytics-web3", [], factory);
	else if(typeof exports === 'object')
		exports["analytics-web3"] = factory();
	else
		root["analytics-web3"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 